// export const BaseUrl = "http://localhost:8000";  
// export const BaseUrl = "http://192.168.18.18:8000";  
export const BaseUrl = "https://be.radiustrend.com";  
export const BaseUrlApi = `${BaseUrl}/api/v1`;